import React, { FC } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AuthGuard from "./AuthGuard";
import { IRoute, PrivateUIRoutes, UIRoutes } from "../router";

import AppLayout from "../components/Layout/AppLayout";
import LandingLayout from "../components/Layout/LandingLayout";

import Login from "../areas/public/pages/Login";
import ControlPanelLayout from "../components/Layout/ControlPanelLayout";
import CI10 from "../areas/public/pages/CI10";
import FearAndGreedIndex from "../components/CryptoMarkets/FearAndGreedIndex";
import CryptoMarkets from "../areas/public/pages/CryptoMarkets";
import Education from "../areas/public/pages/Education";
import CryptoNews from "../areas/public/pages/CryptoNews";
import Blog from "../areas/public/pages/Blog";
import ViewNews from "../areas/public/pages/ViewNews";
import ViewInstrument from "../areas/public/pages/ViewInstrument";
import ViewBlog from "../areas/public/pages/ViewBlog";
import Pages from "../areas/public/pages/Pages";
import ChangeLogs from "../areas/public/pages/ChangeLogs";
import Dashboard from "../areas/admin/pages/Dashboard";
import EngineApp from "../areas/admin/pages/EngineApp";
import UsersList from "../areas/admin/pages/UsersList";
import UserEdit from "../areas/admin/pages/UserEdit";

import InstrumentEdit from "../areas/admin/pages/InstrumentEdit";
import InstrumentsList from "../areas/admin/pages/InstrumentsList";

import IndexEdit from "../areas/admin/pages/IndexEdit";
import IndicesList from "../areas/admin/pages/IndicesList";

import NewsList from "../areas/admin/pages/NewsList";
import NewsEdit from "../areas/admin/pages/NewsEdit";
import MagicPageEdit from "../areas/admin/pages/MagicPageEdit";
import BlogList from "../areas/admin/pages/BlogList";
import BlogEdit from "../areas/admin/pages/BlogEdit";
import SystemSettingsEdit from "../areas/admin/pages/SystemSettingsEdit";
import SystemSettingsList from "../areas/admin/pages/SystemSettingsList";
import ForgotPassword from "../areas/public/pages/ForgotPassword";
import RestorePassword from "../areas/public/pages/RestorePassword";
import EmailTemplatesList from "../areas/admin/pages/EmailTemplatesList";
import EmailTemplateEdit from "../areas/admin/pages/EmailTemplateEdit";
import MagicPagesList from "../areas/admin/pages/MagicPagesList";
import SubscribesList from "../areas/admin/pages/SubscribersList";

export const publicRoutes: IRoute[] = [
  {
    path: UIRoutes.LOGIN,
    element: <Login />,
  },
  {
    path: UIRoutes.FORGOT_PASSWORD,
    element: <ForgotPassword />,
  },
  {
    path: UIRoutes.RESTORE_PASSWORD,
    element: <RestorePassword />,
  },
];

export const appRoutes: IRoute[] = [
  {
    path: UIRoutes.INDICES,
    element: <CI10 />,
  },
  {
    path: UIRoutes.CRYPTO_MARKETS,
    element: <CryptoMarkets />,
  }, 
  {
    path: UIRoutes.EDUCATION,
    element: <Education />,
  },
  {
    path: UIRoutes.CRYPTO_NEWS,
    element: <CryptoNews />,
  },
  {
    path: UIRoutes.VIEW_NEWS,
    element: <ViewNews />,
  },
  {
    path: UIRoutes.VIEW_INSTRUMENT,
    element: <ViewInstrument />,
  },
  {
    path: UIRoutes.BLOG,
    element: <Blog />,
  },
  {
    path: UIRoutes.VIEW_BLOG,
    element: <ViewBlog />,
  },
  {
    path: UIRoutes.VIEW_PAGE,
    element: <Pages />,
  },
  {
    path: UIRoutes.HOME_CHANGE_LOG,
    element: <ChangeLogs />,
  },
];

export const privateRoutes: IRoute[] = [
  {
    path: PrivateUIRoutes.DASHBOARD,
    element: <Dashboard />,
  },
  {
    path: PrivateUIRoutes.ENGINE_APP,
    element: <EngineApp />,
  },

  {
    path: PrivateUIRoutes.USERS,
    element: <UsersList />,
  },
  {
    path: PrivateUIRoutes.VIEW_USER,
    element: <UserEdit />,
  },
  {
    path: PrivateUIRoutes.CREATE_USER,
    element: <UserEdit />,
  },

  {
    path: PrivateUIRoutes.INSTRUMENTS,
    element: <InstrumentsList />,
  },
  {
    path: PrivateUIRoutes.VIEW_INSTRUMENT,
    element: <InstrumentEdit />,
  },
  {
    path: PrivateUIRoutes.CREATE_INSTRUMENT,
    element: <InstrumentEdit />,
  },

  {
    path: PrivateUIRoutes.INDICES,
    element: <IndicesList />,
  },
  {
    path: PrivateUIRoutes.EDIT_INDICES,
    element: <IndexEdit />,
  },
  {
    path: PrivateUIRoutes.CREATE_INDICES,
    element: <IndexEdit />,
  },

  {
    path: PrivateUIRoutes.NEWS,
    element: <NewsList />,
  },
  {
    path: PrivateUIRoutes.VIEW_NEWS,
    element: <NewsEdit />,
  },
  {
    path: PrivateUIRoutes.CREATE_NEWS,
    element: <NewsEdit />,
  },

  {
    path: PrivateUIRoutes.BLOG,
    element: <BlogList />,
  },
  {
    path: PrivateUIRoutes.VIEW_BLOG,
    element: <BlogEdit />,
  },
  {
    path: PrivateUIRoutes.CREATE_BLOG,
    element: <BlogEdit />,
  },

  {
    path: PrivateUIRoutes.MAGIC_PAGES,
    element: <MagicPagesList />,
  },
  {
    path: PrivateUIRoutes.VIEW_MAGIC_PAGE,
    element: <MagicPageEdit />,
  },
  {
    path: PrivateUIRoutes.CREATE_MAGIC_PAGE,
    element: <MagicPageEdit />,
  },

  {
    path: PrivateUIRoutes.SYSTEM_SETTINGS,
    element: <SystemSettingsList />,
  },
  {
    path: PrivateUIRoutes.VIEW_SYSTEM_SETTINGS,
    element: <SystemSettingsEdit />,
  },
  {
    path: PrivateUIRoutes.EMAIL_TEMPLATES,
    element: <EmailTemplatesList />,
  },
  {
    path: PrivateUIRoutes.VIEW_EMAIL_TEMPLATES,
    element: <EmailTemplateEdit />,
  },

  {
    path: PrivateUIRoutes.SUBSCRIBES,
    element: <SubscribesList />,
  },
];

const AppRouter: FC = () => {
  return (
    <Routes>
      <Route path="/*" element={<AppLayout />}>
        {appRoutes.map((route, index) => (
          <Route key={`${route.path}${index}`} {...route} />
        ))}
        <Route path="" element={<CI10 />} />
        <Route
          path="*"
          element={
            <Navigate to={`/${UIRoutes.ACCOUNT}/${UIRoutes.LOGIN}`} replace />
          }
        />
      </Route>

      <Route path={`/${UIRoutes.ACCOUNT}/*`} element={<LandingLayout />}>
        {publicRoutes.map((route, index) => (
          <Route key={`${route.path}${index}`} {...route} />
        ))}
        <Route path="*" element={<Navigate to={`${UIRoutes.LOGIN}`} />} />
      </Route>

      <Route element={<AuthGuard />}>
        <Route path="/controlpanel/*" element={<ControlPanelLayout />}>
          {privateRoutes.map((route, index) => (
            <Route key={`${route.path}${index}`} {...route} />
          ))}
          <Route
            path="*"
            element={<Navigate to={PrivateUIRoutes.DASHBOARD} />}
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRouter;
